// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JeDO4DGhUFIaroxUzU0t{align-items:center;gap:10px;display:flex}.r4ahY0t9miAj20rlWK3L{gap:8px;margin-top:12px;display:flex}.FmD3DC4ISYU9XUt_6CfF{margin-top:24px;overflow-y:auto}.CBGKT8rHYw4Eb43I4adj{flex-direction:column;gap:16px;margin-top:32px;display:flex}.EOOvkHVAsZ4Hh3PbvGSS{letter-spacing:-.4px;max-width:256px}.ZC9Wpot5_RM8Rc2pEtBI{max-width:226px}.zB8LuuFOEdJaNIPrKwI8{margin-top:24px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"titleWrap": `JeDO4DGhUFIaroxUzU0t`,
	"info": `r4ahY0t9miAj20rlWK3L`,
	"bodyWrap": `FmD3DC4ISYU9XUt_6CfF`,
	"keywordParamsWrap": `CBGKT8rHYw4Eb43I4adj`,
	"keywordName": `EOOvkHVAsZ4Hh3PbvGSS`,
	"keywordTitle": `ZC9Wpot5_RM8Rc2pEtBI`,
	"alert": `zB8LuuFOEdJaNIPrKwI8`
};
export default ___CSS_LOADER_EXPORT___;
